var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('VideoComponentPcm'),_c('pcm-aseg'),_c('pcm-bseg'),_c('pcm-cseg'),_c('pcm-dseg'),_c('white-label'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }